import React, {Component, PropTypes} from 'react'
import {FaVenusMars, FaBirthdayCake, MdLockOutline, MdMailOutline, MdFace, MdPhoneIphone, MdPhone} from '../../Common/ReactIcons/icons'

class ProfileInfo extends Component {
  render () {
    const {info} = this.props
    return (
      <div className="ProfileInfo">
        <dl className="row">
          <dt className="col-sm-12 col-md-4"><MdLockOutline /> نام کاربری:</dt>
          <dd className="col-sm-12 col-md-8">{info.username}</dd>

          <dt className="col-sm-12 col-md-4"><MdMailOutline />ایمیل:</dt>
          <dd className="col-sm-12 col-md-8">{info.email}</dd>

          <dt className="col-sm-12 col-md-4"><MdFace /> نام:</dt>
          <dd className="col-sm-12 col-md-8">{info.full_name_fa ? info.full_name_fa : '-'}</dd>

          <dt className="col-sm-12 col-md-4"><MdFace /> نام (به انگلیسی):</dt>
          <dd className="col-sm-12 col-md-8">{info.full_name ? info.full_name : '-'}</dd>

          <dt className="col-sm-12 col-md-4"><FaVenusMars /> جنسیت:</dt>
          <dd className="col-sm-12 col-md-8">{info.gender ? (info.gender === 'male' ? 'آقا' : 'بانو') : '-'}</dd>

          <dt className="col-sm-12 col-md-4"><FaBirthdayCake /> تاریخ تولد:</dt>
          <dd className="col-sm-12 col-md-8">{info.birthday ? info.birthday : '-'}</dd>

          <dt className="col-sm-12 col-md-4"><MdPhoneIphone /> موبایل:</dt>
          <dd className="col-sm-12 col-md-8">{info.mobile ? info.mobile : '-'}</dd>

          <dt className="col-sm-12 col-md-4"><MdPhone /> تلفن:</dt>
          <dd className="col-sm-12 col-md-8">{info.phone ? info.phone : '-'}</dd>

        </dl>
      </div>
    )
  }
}

ProfileInfo.propTypes = {
  info: PropTypes.object.isRequired
}

export default ProfileInfo



// WEBPACK FOOTER //
// ./src/components/User/Profile/ProfileInfo.js